import ConfiguratorRollingGate from './util/ConfiguratorRollingGate';
import $ from 'jquery';
import kampaConfiguratorData from 'kampaConfiguratorData';

const form = $('#configurator-form');
const submitButton = $('#configurator-submit-button');

let fixedSlant = null;

let Config = new ConfiguratorRollingGate(kampaConfiguratorData);
if($('#height').length){
	if($('#height').length){
		Config.hasDifferentHeights = false;
	}
}

/**
 * Init
 */
init();
function init(){
	Config.init(document.getElementById('configurator-container'));
	updateSizes();
	handleFabrics();
	handleColors();
	handleMountingType();
	handleRailHolders();
	handleControl();
	handleWindowsButtonView();
	updateWindowsTabs();
	handleWindows();
	handleExtras();
	handleForm();
}

window.addEventListener('resize',function(){
	Config = new ConfiguratorRollingGate(kampaConfiguratorData);
	init();
});

/**
 * Dimensions
 */


$('#width').change(updateSizes);
$('#height').change(updateSizes);
$('#height_left').change(updateSizes);
$('#height_right').change(updateSizes);
$('#slant').change(updateSizes);
function updateSizes(){
	let width = parseInt( $('#width').val() );
	let heightLeft = 0;
	let heightRight = 0;
	let slantRow = $('#slant-row');
	let slant = fixedSlant != null ? fixedSlant : $('#slant').val();

	if($('#height').length){
		let height = parseInt( $('#height').val() );
		heightLeft = height;
		heightRight = height;
	}
	else{
		heightLeft = parseInt( $('#height_left').val() );
		heightRight = parseInt( $('#height_right').val() );
	}

	if(heightLeft != heightRight && fixedSlant == null) slantRow.show();
	else slantRow.hide();

	Config.setTarpSize(width*10, heightLeft*10, heightRight*10, slant);
}


/**
 * Fabrics
 */
$('.fabric-field').change(handleFabrics);
function handleFabrics(){
	let selected = $('.fabric-field:checked');
	let fabric = selected.val();
	let productId = selected.data('product_id');
	let url = selected.data('url');
	let colorFields = $('.configurator-colors .color-field.'+fabric);

	form.attr('action',url);
	submitButton.attr('value',productId);

	$('.configurator-fabrics .fabric-info').removeClass('active');
	$('.configurator-fabrics .fabric-info.'+fabric).addClass('active');
	$('.configurator-header__close').attr('href',url);
	$('.configurator-colors .color-field').removeClass('active');
	colorFields.addClass('active');

	$('.configurator-colors__pattern-link').removeClass('active');
	$('#pattern-link-'+fabric).addClass('active');

	if(colorFields.find('.color-input:checked').length === 0){

		let colorField = colorFields.find('.color-input').first()
		colorField.prop('checked',true);
		colorField.trigger('change');
	}
}


/**
 * Colors
 */
$('.color-input').change(handleColors);
function handleColors(){
	let selected = $('.color-input:checked');
	let color = selected.data('hex');
	Config.setTarpColor(color);
}

/**
 * Mounting type
 */
$('input[name="mounting_type"]').change(handleMountingType);
function handleMountingType()
{
	let holdersSection = $('#rolling-gate-rail-holders');
	let mountingType = $('input[name="mounting_type"]:checked').val();

	holdersSection.hide();

	if(mountingType == 'guide'){
		holdersSection.show();
	}

	Config.setMountingType(mountingType);
}

/**
 * Rail holders
 */
$('input[name="rail_holders"]').change(handleRailHolders);
function handleRailHolders()
{
	let val = $('input[name="rail_holders"]:checked').val();
	Config.setRailHolders(val);
}

/**
 * Control
 */
$('#control').change(handleControl);
$('#control_side').change(handleControl);
function handleControl()
{
	let control = $('#control').val();
	let side = $('#control_side').val();

	Config.setControl(control, side);
}

/**
 * Windows
 */
let windowsLimit = 4;
$('#configurator-add-window-button').click(function(e){
	e.preventDefault();
	let tabs = $('#windows-options .configurator-tab');
	let windowsCount = tabs.length;

	if(windowsCount < windowsLimit){
		tabs.removeClass('active');
		tabs.find('.configurator-tab__content').slideUp();
		let copyEl = $('#window-options-copy').clone(true);

		var re = new RegExp('{index}','g');
		var reName = new RegExp('__name','g');
		let uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
		copyEl.html( copyEl.html().replace(re,uid).replace(reName,'name') );

		$('#windows-options').append(copyEl.html());

		updateWindowsTabs();
		handleWindows();
	}

	handleWindowsButtonView();
});

function updateWindowsTabs(){
	let tabs = $('#windows-options .configurator-windows__tab');
	tabs.each(function(i,el){
		var re = new RegExp('{number}','g');
		let tab = $(el);
		let titleEl = tab.find('.configurator-tab__title');
		let titlePattern = titleEl.data('title');
		titleEl.html(titlePattern.replace(re,i+1));
	});
	form.trigger('change');
}

function handleWindowsButtonView(){
	let tabs = $('#windows-options .configurator-windows__tab');
	let windowsCount = tabs.length;
	let buttonWrap = $('.configurator-windows__button-wrap');

	if(windowsCount >= windowsLimit){
		buttonWrap.hide();
	}
	else{
		buttonWrap.show();
	}
}

$(document).on('click', '.configurator-windows__delete-button', function(e){
	e.preventDefault();
	let tab = $(this).parents('.configurator-windows__tab');
	let uid = $(this).data('uid');
	tab.remove();

	Config.deleteWindow(uid);
	handleWindowsButtonView();
	updateWindowsTabs();
});

$(document).on('change', '.configurator-window-option-field', handleWindows);
function handleWindows(){
	$('#windows-options .configurator-windows__tab').each(function(i,el){
		let uid = $(el).find('.configurator-tab__header').data('uid');
		let windowType = $(el).find('.window_type').val();
		let windowWidth = parseInt( $(el).find('.window_width').val() ) * 10;
		let windowHeight = parseInt( $(el).find('.window_height').val() ) * 10;
		let windowOffsetLeft = parseInt( $(el).find('.window_offset_left').val() ) * 10;
		let windowOffsetBottom = parseInt( $(el).find('.window_offset_bottom').val() ) * 10;

		Config.addWindow(uid, windowWidth, windowHeight, windowOffsetLeft, windowOffsetBottom, windowType);
	});
}

window.addEventListener(
	'configurator_window_moved',
	function(e){
		$('input[name="windows['+e.detail.uid+'][window_offset_left]"').val(Math.round(e.detail.offsetLeft/10));
		$('input[name="windows['+e.detail.uid+'][window_offset_bottom]"').val(Math.round(e.detail.offsetBottom/10));
		form.trigger('change');
	},
	false
);

/**
 * Extras
 */
$('input[name=dirt_lap]').change(handleDirtLapExtras);

function handleExtras(){
	handleDirtLapExtras();
}

function handleDirtLapExtras(){
	if($('input[name=dirt_lap]').is(':checked')){
		Config.addDirtLap();
	}
	else{
		Config.removeDirtLap();
	}
}

/**
 * Tabs
 */
$('.configurator-tab.active .configurator-tab__content').slideDown();

$(document).on('click', '.configurator-tab__arrow', function(e){
	e.preventDefault();
	let tab = $(this).parents('.configurator-tab');
	let tabContent = tab.find('.configurator-tab__content');
	tabContent.slideToggle();
	tab.toggleClass('active');
});

$(document).on('click', '.configurator-tab__header', function(e){
	e.preventDefault();
	if(e.target == this){
		let tab = $(this).parents('.configurator-tab');
		let tabContent = tab.find('.configurator-tab__content');
		tabContent.slideDown();
		tab.addClass('active');
	}
});


/**
 * Errors
 */
window.addEventListener(
	'configurator_errors_update',
	handleConfiguratorErrors,
	false
);
function handleConfiguratorErrors(){
	let errors = Config.getErrors();
	$('.configurator-error').hide();

	if(errors.length){
		disableForm();
		errors.forEach(function(key){
			$('#configurator-error-'+key).show();
		});
	}
	else{
		enableForm();
	}
}

/**
 * Events
 */
window.addEventListener('configurator_dimension_click',function(e){
	let id = e.detail.name;
	let field = $('#'+id);
	let heightField = $('#height');

	if(heightField.length && (id == 'height_left' || id == 'height_right')){
		field = heightField;
	}

	field.focus();
	field.select();
},false);

/**
 * Form
 */
let doingProductFormAjax = false;
let productFormData = null;

form.change(handleForm);
form.on('keyup keypress', function(e) {
	var keyCode = e.keyCode || e.which;
	if (keyCode === 13) {
		e.preventDefault();
		return false;
	}
});
function handleForm() {
	productFormData = new FormData(form[0]);
	doProductFormAjax();
}

function doProductFormAjax(){

	if(productFormData === null || doingProductFormAjax) return;

	var formData = productFormData;
	formData.append('action','kampa_configurator_calculation');

	productFormData = null;
	doingProductFormAjax = true;

	disableForm();

	$.ajax({
		type: 'POST',
		url: kampa.ajax_url,
		data: formData,
		processData: false,
		contentType: false,
		success: function (res) {
			let data = JSON.parse(res);

			doingProductFormAjax = false;
			doProductFormAjax();

			$('.warning').html('');
			$('.field-warning').removeClass('field-warning');
			if(!data.validation.result){
				data.validation.warnings.forEach(function(e){
					let warningEl = $('#warning-' + e.key);
					warningEl.html(e.msg);
					$('#' + warningEl.data('field')).addClass('field-warning');
				});
			}
			else {
				$('.configurator-price').html(data.price_html);
				enableForm();
			}


			handleConfiguratorErrors();
		},
	});
}

function disableForm(){
	$('.configurator-price').html('<i class="fas fa-spinner fa-spin spinner"></i>');
	submitButton.attr('disabled',true);
}

function enableForm(){
	submitButton.attr('disabled',false);
}

/**
 * Mobile
 */
$('#configurator-preview-button').click(function(e){
	e.preventDefault();
	$('.configurator-page__image').addClass('active');
});

$('#configurator-preview-close-button').click(function(e){
	e.preventDefault();
	$('.configurator-page__image').removeClass('active');
});



// WEBPACK FOOTER //
// ./scripts/configuratorRollingGate.js